module.exports =(function() {
  return function(context) {
    return (function() {
      var $o, pendingCount;
      $o = [];
      pendingCount = this.inflector.pluralize("project", this.collection.pendingCount());
      $o.push("<span>\n  Status: Importing\n  <var>" + pendingCount + "</var>\n  projects\n</span>");
      if (this.showWarning) {
        $o.push("<br>\n<strong>\n  This may take a while.\n</strong>\nPlease don't close this page until we've added all your projects.");
      }
      return $o.join("\n");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/import_status.js.hamlc
// module id = 279
// module chunks = 15